/* Mobil yapışkan sepete ekle çubuğu: asıl "Add to cart" butonu görünmüyorsa (ve sayfa biraz kaydırıldıysa) çubuğu göster.
   Konum kaydırmada getBoundingClientRect ile hesaplanır (IntersectionObserver arka plandaki sayfada geç/hiç çalışmayabiliyor). */
class NilyaStickyAtc extends HTMLElement {
  connectedCallback() {
    this.target = document.getElementById(this.dataset.target);
    if (!this.target) return;
    this.ticking = false;
    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  update() {
    const rect = this.target.getBoundingClientRect();
    const targetVisible = rect.bottom > 0 && rect.top < window.innerHeight;
    this.hidden = targetVisible || window.scrollY < 160;
  }
}
customElements.define('nilya-sticky-atc', NilyaStickyAtc);
